import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor() {
        return new.target.k1z();
      }
      static k1z() {
        NoOpEncoder_instance = null;
        var $this = this.q1r();
        NoOpEncoder_instance = $this;
        $this.j1z_1 = EmptySerializersModule();
        return $this;
      }
      m1r() {
        return this.j1z_1;
      }
      s1r(value) {
        return Unit_instance;
      }
      t1r() {
        return Unit_instance;
      }
      u1r(value) {
        return Unit_instance;
      }
      v1r(value) {
        return Unit_instance;
      }
      w1r(value) {
        return Unit_instance;
      }
      x1r(value) {
        return Unit_instance;
      }
      y1r(value) {
        return Unit_instance;
      }
      z1r(value) {
        return Unit_instance;
      }
      a1s(value) {
        return Unit_instance;
      }
      b1s(value) {
        return Unit_instance;
      }
      c1s(value) {
        return Unit_instance;
      }
      d1s(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().k1z();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstance3smymz61up1q7,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
